require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-to-further-maximize-the-project-outcomesof-a-world.json") })
        }
      }, "path---en-us-update-to-further-maximize-the-project-outcomesof-a-world");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-to-further-maximize-the-project-outcomesof-a-world!./.cache/json/en-us-update-to-further-maximize-the-project-outcomesof-a-world.json
// module id = 811
// module chunks = 231608221292675